import React, { useContext, useCallback } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { convertUndefinedFields } from 'utils/helpers';
import { IEditModifierContext, EditModifierContext } from '../editModifierState/editModifierContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { updateModifierV2 } from 'backend/modifiers';
import { useGoBack } from 'hooks/useGoBack';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, setFileId, refetchData, dataForSubmit, typeOfModalWindow } =
		useContext<IEditModifierContext>(EditModifierContext);
	const goBack = useGoBack();

	const handleRedirect = useCallback(() => {
		goBack('/menu-v2/modifiers');
	}, [goBack]);

	const handleConfirm = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateModifierV2(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleUpdateData = useCallback(() => {
		setFileId(null);
		refetchData(true);
		changeTypeOfModalWindow(null);
	}, []);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'toConfirmFieldsClearing' && (
				<ModalToConfirm
					onConsentEvent={handleRedirect}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="cancelSaveInfo"
				/>
			)}
			{typeOfModalWindow === 'toConfirmSubmit' && (
				<ModalToConfirm
					onConsentEvent={handleConfirm}
					onFailureEvent={handleCloseModal}
					isVisible={typeOfModalWindow === 'toConfirmSubmit'}
					description="saveInfo"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={handleUpdateData}
					isVisible={true}
					description="savedSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError onConsentEvent={handleCloseModal} isVisible={true} description="errorWhileSaving" />
			)}
			{typeOfModalWindow === 'defaultTranslationIsEmpty' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorDefaultTranslationOnBlock"
				/>
			)}
		</ModalWrapper>
	);
};
